import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useMatch, useNavigate } from 'react-router';

import useAccountQuery from 'api/queries/useAccountQuery';
import useSelectionsQuery from 'api/queries/useSelectionsQuery';
import Tabs from 'honeydew/Tabs';
import useGlobalStore from 'hooks/useGlobalStore';

import AvailableGiftsTab from './AvailableGiftsTab';
import RedeemedGiftsTab from './RedeemedTab';

const tabPaths = {
    tab1: '/shop/browse/misfits+perks',
    tab2: '/shop/browse/misfits+perks/redeemed',
};

function ProductTabs({ products }) {
    const { data: account = {} } = useAccountQuery();
    const { data: selections = {} } = useSelectionsQuery();

    const navigate = useNavigate();
    const isReedemedPath = useMatch(tabPaths.tab2);
    const { alerts } = useGlobalStore();
    const [currentTab, setCurrentTab] = useState(isReedemedPath ? 'tab2' : 'tab1');

    const showMaxLoyaltyPointsSpendAlert =
        alerts?.includes('maxLoyaltyPointsSpendAlert') || selections?.selected?.some((selection) => selection?.isPerk);

    useEffect(() => {
        if (isReedemedPath) {
            setCurrentTab('tab2');
        }
    }, [isReedemedPath]);

    useEffect(() => {
        navigate(tabPaths[currentTab]);
    }, [currentTab]);

    useEffect(() => {
        if (showMaxLoyaltyPointsSpendAlert) {
            document.getElementById('max-loyalty-point-spend-alert')?.scrollIntoView({ behavior: 'smooth' });
        }
    }, [showMaxLoyaltyPointsSpendAlert]);

    const redeemedItems = selections?.selected?.filter((selection) => selection?.isPerk) ?? [];
    const redeemedItemQty = redeemedItems.reduce((a, b) => a + b.qty, 0);

    return (
        <Tabs
            onValueChange={(value) => setCurrentTab(value)}
            tabOptions={[
                {
                    id: 1,
                    name: 'Available Gifts',
                    content: (
                        <AvailableGiftsTab
                            currentLoyaltyPoints={account?.currentLoyaltyPoints}
                            isDeliveredByImperfect={account?.isDeliveredByImperfect}
                            showMaxLoyaltyPointsSpendAlert={showMaxLoyaltyPointsSpendAlert}
                            products={products}
                        />
                    ),
                },
                {
                    id: 2,
                    name: <>Redeemed ({redeemedItemQty})</>,
                    content: (
                        <RedeemedGiftsTab
                            currentLoyaltyPoints={account?.currentLoyaltyPoints}
                            isDeliveredByImperfect={account?.isDeliveredByImperfect}
                            showMaxLoyaltyPointsSpendAlert={showMaxLoyaltyPointsSpendAlert}
                            setCurrentTab={setCurrentTab}
                            selections={selections}
                        />
                    ),
                },
            ]}
            tabWrapperClasses="bg-off-white flex justify-center pt-15 -mx-10 md:mx-0"
            value={currentTab}
        />
    );
}

ProductTabs.propTypes = {
    products: PropTypes.arrayOf(PropTypes.shape({ pointPrice: PropTypes.number.isRequired })).isRequired,
};

export default ProductTabs;
